<template>
  <div>
    <v-card
      :style="[
        $vuetify.breakpoint.smAndDown
          ? { 'min-height': '100vh', 'background-color': '#f9f9f9' }
          : { 'background-color': '#f9f9f9' },
      ]"
    >
      <div style="margin-left: 10px; margin-right: 10px">
        <div
          class="pt-8"
          style="
            font-size: 20px;
            margin-left: 1rem;
            margin-right: 1rem;
            color: #444444;
          "
        >
          Manage Holiday
        </div>
        <v-card-text>
          <div>
            <v-card
              elevation="10"
              style="padding: 2%; margin-bottom: 2%; margin-top: 2%"
            >
              <v-row>
                <v-col cols="12" sm="6" md="2" lg="2" class="pt-5">
                  <v-select
                    :items="['Active', 'InActive']"
                    label="Status"
                    v-model="activeStatus"
                    required
                    clearable
                    outlined
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="4" class="pt-5">
                  <v-text-field
                    label="Search"
                    append-icon="mdi-database-search-outline"
                    v-model="search"
                    v-on:keyup.enter="SearchDataHoliday(search)"
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>

                <!-- <v-col cols="12" sm="6" md="4" lg="4" style="text-align: end">
             
                </v-col> -->
                <v-col cols="12" sm="6" md="6" lg="6" style="text-align: end">
                  <v-hover v-slot="{ hover }">
                    <v-btn
                      :color="'blue'"
                      class="ma-2 white--text"
                      :elevation="hover ? 10 : 2"
                      :class="{ 'on-hover': hover }"
                      @click="SearchDataHoliday(search)"
                    >
                      Search

                      <v-icon right> mdi-magnify </v-icon>
                    </v-btn>
                  </v-hover>
                  <v-hover v-slot="{ hover }">
                    <v-btn
                      v-if="permissionsPage.create"
                      color="green"
                      class="ma-2 white--text"
                      :elevation="hover ? 10 : 2"
                      :class="{ 'on-hover': hover }"
                      @click="OpenEditDialog('create', null)"
                    >
                      Create
                      <v-icon right> mdi-plus </v-icon>
                    </v-btn>
                  </v-hover>
                </v-col>
              </v-row>
            </v-card>

            <v-card
              elevation="10"
              style="padding: 2%; margin-top: 2%; margin-bottom: 2%"
            >
              <v-row>
                <v-col cols="12" md="4"></v-col>
                <v-col cols="12" md="3"></v-col>
                <v-col cols="12" md="5" align="center">
                  <v-pagination
                    v-model="page"
                    :total-visible="6"
                    :length="pageCount"
                    @input="ChangePage(page)"
                  ></v-pagination>
                </v-col>
              </v-row>
              <v-data-table
                :headers="headers"
                :items="DataList"
                hide-default-footer
                style="color: #332f2fde"
                :items-per-page="itemsPerPage"
                :page.sync="page"
                single-line
                hide-details
              >
                <template v-slot:item="{ item, index }">
                  <tr>
                    <td class="header-table-css">{{ no_run + (index + 1) }}</td>
                    <td class="header-table-css">{{ item.holidayName }}</td>
                    <td class="header-table-css">
                      {{ ChangeFormatDateOnly(item.holidayDate) }}
                    </td>
                    <td
                      style="
                        padding-bottom: 5px;
                        display: flex;
                        flex-direction: column-reverse;
                        align-items: center;
                      "
                    >
                      <v-btn
                        :color="GetColor(item.active)"
                        rounded
                        class="text-capitalize"
                        depressed
                        style="width: 140px"
                      >
                        <span :style="{ color: GetColorText(item.active) }">{{
                          item.active == true ? "Active" : "InActive"
                        }}</span>
                      </v-btn>
                    </td>
                    <td style="text-align: center; min-width: 150px">
                      <v-btn
                        class="mx-2"
                        fab
                        dark
                        small
                        color="orange"
                        @click="OpenEditDialog('edit', item)"
                      >
                        <v-icon dark> mdi-pencil-outline </v-icon>
                      </v-btn>
                      <v-btn
                        v-if="permissionsPage.delete"
                        class="mx-2"
                        fab
                        dark
                        small
                        color="red"
                        @click="inActiveHolidayByID(item.id)"
                      >
                        <v-icon dark>mdi-trash-can-outline </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <br />
              <v-row class="mt-5">
                <v-col cols="12" md="4"></v-col>
                <v-col cols="12" md="3">
                  <v-pagination
                    v-model="page"
                    :total-visible="20"
                    :length="pageCount"
                    @input="ChangePage(page)"
                  ></v-pagination>
                </v-col>
                <v-col cols="12" md="3"></v-col>
                <v-col cols="12" md="2">
                  <v-autocomplete
                    dense
                    solo
                    label="10/page"
                    v-model="itemsPerPage"
                    @input="ChangePerPage(itemsPerPage)"
                    :items="items"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog v-model="HolidayDialog" persistent max-width="800px">
      <v-card>
        <v-card-title
          style="background-color: black; color: white; padding: 5px"
        >
          <v-col cols="6" sm="6" md="6" style="text-align: start">
            <span v-if="EditStatus" class="text-h5">Edit Holiday</span>
            <span v-else class="text-h5">Create Holiday</span>
          </v-col>
          <v-col cols="6" sm="6" md="6" style="text-align: end">
            <v-tooltip bottom color="white" v-if="EditStatus">
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="white" v-bind="attrs" v-on="on">
                  mdi-information
                </v-icon>
              </template>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  style="font-size: 15px; color: black"
                >
                  Create By : {{ createBy }} &nbsp;
                  {{ ChangeFormatDate(createTime) }}<br />
                  Update By : {{ updateBy }} &nbsp;
                  {{ ChangeFormatDate(updateTime) }}<br />
                </v-col>
              </v-row>
            </v-tooltip>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Holiday Name*"
                  v-model="HolidayName"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-menu
                  v-model="menuHolidayDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="HolidayDate"
                      label="Holiday Date*"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="HolidayDate"
                    @change="menuHolidayDate = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="1">
                <v-switch
                  v-model="StatusActive"
                  hide-details
                  inset
                  :label="StatusActive ? 'Active' : 'InActive'"
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              style="text-align: end; margin-bottom: 20px"
            >
              <v-spacer></v-spacer>
              <v-btn
                v-if="EditStatus == false && permissionsPage.create"
                class="ma-2"
                style="min-width: 100px"
                color="success"
                @click="addHoliday()"
              >
                Save
                <template v-slot:loader>
                  <span class="custom-loader">
                    <v-icon light>mdi-cached</v-icon>
                  </span>
                </template>
              </v-btn>
              <v-btn
                v-if="EditStatus == true && permissionsPage.update"
                class="ma-2"
                style="min-width: 100px"
                color="success"
                @click="addHoliday()"
              >
                Update
                <template v-slot:loader>
                  <span class="custom-loader">
                    <v-icon light>mdi-cached</v-icon>
                  </span>
                </template>
              </v-btn>
              <v-btn
                variant="outlined"
                color="silver"
                style="min-width: 100px"
                append-icon="mdi-close-circle-outline"
                @click="CloseDataDialog()"
              >
                Close
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <div class="loading-box">
        <div class="inter-load">
          <div class="rect rect1"></div>
          <div class="rect rect2"></div>
          <div class="rect rect3"></div>
          <div class="rect rect4"></div>
          <div class="rect rect5"></div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { eventBus } from "../../main";

export default {
  name: "ManageHoliday",
  components: {},
  data() {
    return {
      loader: null,
      url: enurl.apiUrl,
      LoadingDialog: false,
      items: [10, 15, 20, 50, 100],
      no_run: null,
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,

      DataList: [],
      search: "",
      activeStatus: null,

      HolidayID: null,
      HolidayName: "",
      HolidayDate: "",
      menuHolidayDate: false,
      HolidayDialog: false,
      Status: "",
      StatusActive: false,
      EditStatus: false,

      permissionsPage: [],

      createBy: "",
      createTime: "",
      updateBy: "",
      updateTime: "",
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "No",
          sortable: false,
          align: "left",
        },
        {
          text: "HolidayName",
          align: "left",
          sortable: false,
        },
        {
          text: "HolidayDate",
          align: "left",
          sortable: false,
        },
        {
          text: "Active",
          align: "center",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ];
    },
  },

  mounted() {
    let self = this;
    let Permision = localStorage.getItem("Permision");
    if (Permision == null || Permision == "") {
      this.$router.push("/Main");
    }
    let page = localStorage.getItem("page");
    this.permissionsPage = JSON.parse(Permision).find((x) => x.appName == page);

    self.getDataHolidayList();
  },

  methods: {
    getDataHolidayList() {
      let self = this;
      self.LoadingDialog = true;
      self.page = 1;
      let temp = {
        page: 1,
        perpage: self.itemsPerPage,
        search: self.search == null ? "" : self.search,
        active:
          self.activeStatus == "Active"
            ? true
            : self.activeStatus == null
            ? null
            : false,
      };
      axios
        .post(`${self.url}Rate/getHolidayList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.DataList = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
        })
        .catch(function (error) {
          let message = "เกิดข้อผิดพลาด";
          if (error.response && error.response.data) {
            message = error.response.data.message || message;
          }
          Swal.fire({
            icon: "error",
            width: 900,
            text: message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    ChangePage(value) {
      let self = this;
      self.LoadingDialog = true;
      self.page = value;
      let temp = {
        page: value,
        perpage: self.itemsPerPage,
        search: self.search == null ? "" : self.search,
        active:
          self.activeStatus == "Active"
            ? true
            : self.activeStatus == null
            ? null
            : false,
      };
      axios
        .post(`${self.url}Rate/getHolidayList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.DataList = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
        })
        .catch(function (error) {
          let message = "เกิดข้อผิดพลาด";
          if (error.response && error.response.data) {
            message = error.response.data.message || message;
          }
          Swal.fire({
            icon: "error",
            width: 900,
            text: message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    ChangePerPage(value) {
      let self = this;
      self.LoadingDialog = true;
      self.page = 1;
      let temp = {
        page: 1,
        perpage: value,
        search: self.search == null ? "" : self.search,
        active:
          self.activeStatus == "Active"
            ? true
            : self.activeStatus == null
            ? null
            : false,
      };
      axios
        .post(`${self.url}Rate/getHolidayList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.DataList = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
        })
        .catch(function (error) {
          let message = "เกิดข้อผิดพลาด";
          if (error.response && error.response.data) {
            message = error.response.data.message || message;
          }
          Swal.fire({
            icon: "error",
            width: 900,
            text: message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    SearchDataHoliday(data) {
      let self = this;
      self.LoadingDialog = true;
      self.page = 1;
      let temp = {
        page: 1,
        perpage: self.itemsPerPage,
        search: data,
        active:
          self.activeStatus == "Active"
            ? true
            : self.activeStatus == null
            ? null
            : false,
      };
      axios
        .post(`${self.url}Rate/getHolidayList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.DataList = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
        })
        .catch(function (error) {
          let message = "เกิดข้อผิดพลาด";
          if (error.response && error.response.data) {
            message = error.response.data.message || message;
          }
          Swal.fire({
            icon: "error",
            width: 900,
            text: message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    ChangeFormatDate(date) {
      if (!date) return null;

      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },

    ChangeFormatDateOnly(date) {
      if (!date) return null;

      var DateData = new Date(date);
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear()
      );
    },

    checkVakidates() {
      let self = this;
      if (
        self.HolidayName == "" ||
        self.HolidayDate == "" ||
        self.activeStatus == ""
      ) {
        return true;
      } else {
        return false;
      }
    },

    getActiveStatus(){
      let self = this;
      if(self.Status == "Active")
      {
        return true;
      }else{
        return false;
      }
    },

    addHoliday() {
      let self = this;
      if (self.checkVakidates()) {
        Swal.fire({
          icon: "warning",
          title: "กรุณากรอกข้อมูลให้ครบถ้วน",
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      self.LoadingDialog = true;
      if (!self.EditStatus) {
        let temp = {
          holidayName: self.HolidayName,
          holidayDate: self.HolidayDate,
          active: self.StatusActive,
        };
        axios
          .post(`${self.url}Rate/addHoliday`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              Swal.fire({
                icon: "success",
                title: "Success",
                showConfirmButton: false,
                timer: 1500,
              });
              self.CloseDataDialog();
              self.getDataHolidayList();
            }
            if (response.data.status == 2) {
              eventBus.$emit("logout");
            }
          })
          .catch(function (error) {
            let message = "เกิดข้อผิดพลาด";
            if (error.response && error.response.data) {
              message = error.response.data.message || message;
            }
            Swal.fire({
              icon: "error",
              width: 900,
              text: message,
            });
          })
          .finally(() => {
            self.LoadingDialog = false;
          });
      } else {
        let temp = {
          id: self.HolidayID,
          holidayName: self.HolidayName,
          holidayDate: self.HolidayDate,
          active: self.StatusActive,
        };
        axios
          .post(`${self.url}Rate/updateHoliday`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              Swal.fire({
                icon: "success",
                title: "Success",
                showConfirmButton: false,
                timer: 1500,
              });
              self.CloseDataDialog();
              self.getDataHolidayList();
            }
            if (response.data.status == 2) {
              eventBus.$emit("logout");
            }
          })
          .catch(function (error) {
            let message = "เกิดข้อผิดพลาด";
            if (error.response && error.response.data) {
              message = error.response.data.message || message;
            }
            Swal.fire({
              icon: "error",
              width: 900,
              text: message,
            });
          })
          .finally(() => {
            self.LoadingDialog = false;
          });
      }
    },

    GetColor(value) {
      if (value == true) {
        return "rgb(92, 184, 92,0.3)";
      } else {
        return "rgb(232, 34, 34,0.3)";
      }
    },

    GetColorText(value) {
      if (value == true) {
        return "rgb(92, 184, 92)";
      } else {
        return "rgb(232, 34, 34)";
      }
    },

    OpenEditDialog(module, data) {
      let self = this;
      if (module == "create") {
        self.HolidayID = null;
        self.HolidayName = "";
        self.HolidayDate = "";
        self.EditStatus = false;
        self.HolidayDialog = true;
      } else {
        self.BindingEditData(data);
      }
    },

    CloseDataDialog() {
      let self = this;
      self.HolidayID = null;
      self.HolidayDate = "";
      self.HolidayName = "";
      self.Status = "";
      self.HolidayDialog = false;
    },

    inActiveHolidayByID(id) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        id: id,
      };
      Swal.fire({
        title: "InActive",
        text: "Do you want to InActive this Holiday ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Submit",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .post(`${self.url}Rate/inactiveHolidayByID`, temp)
            .then(function (response) {
              if (response.data.status == 0) {
                self.SearchDataHoliday();
                Swal.fire(
                  "Deleted!",
                  "Your Data has been Inactive.",
                  "success"
                );
              }
              if (response.data.status == 2) {
                eventBus.$emit("logout");
              }
              self.LoadingDialog = false;
            })
            .catch(function (error) {
              let message = "เกิดข้อผิดพลาด";
              if (error.response && error.response.data) {
                message = error.response.data.message || message;
              }
              Swal.fire({
                icon: "error",
                width: 900,
                text: message,
              });
            })
            .finally(() => {
              self.LoadingDialog = false;
            });
        }
      });
    },

    BindingEditData(data) {
      let self = this;
      self.HolidayID = data.id;
      self.HolidayName = data.holidayName;
      self.HolidayDate = self.ConvertDate(data.holidayDate);
      self.Status = data.active == true ? "Active" : "InActive";
      self.StatusActive = data.active ;
      self.EditStatus = true;
      self.HolidayDialog = true;
      console.log(self.Status );
    },

    ConvertDate(value) {
      if (value != "") {
        return value.split("T")[0];
      }
    },
  },
};
</script>
<style scoped>
* >>> .v-data-table-header {
  background-color: black !important;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}
.addUserTitle {
  font-size: 14px;
  font-weight: 300;
}
.input-border {
  border: 1px solid black;
  height: 35px;
  padding: 4px;
}
.validation-class {
  color: red;
  font-size: 12px;
}
.header-table-css {
  text-align: left;
  cursor: pointer;
}

*,
::before ::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  background-color: #555555;
}

.loading-box {
  width: 150px;
  height: 100px;
  border: 5px solid #f1f1f1;
  /* margin: 100px auto; */
  position: relative;
}

.inter-load {
  width: 100px;
  height: 50px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.rect {
  background: #f1f1f1;
  display: inline-block;
  height: 60px;
  width: 7px;
  margin: 0 1px;
  animation: load 1.3s infinite ease-in-out;
}

@keyframes load {
  0% {
    transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
  }
  40% {
    transform: scaleY(0.4);
  }
  100% {
    transform: scaleY(0.4);
  }
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

.rect2 {
  animation-delay: -1.2s;
}
.rect3 {
  animation-delay: -1.1s;
}
.rect4 {
  animation-delay: -1s;
}
.rect5 {
  animation-delay: -0.9s;
}
</style>
